import * as Styled from '../styled'
import MissingPage from '~components/svgs/MissingPage'
import Button from '~components/dumbs/Button'
import { useNavigate } from '~hooks'

function GenericError() {
  const navigate = useNavigate()

  function handleClick() {
    navigate('/entrar', { state: { previousPath: '/erro' } })
  }

  return (
    <Styled.Wrapper role="region">
      <MissingPage />
      <Styled.Title>Algo deu errado</Styled.Title>
      <Styled.Description>
        Estamos trabalhando para resolver esse problema. Volte novamente mais tarde.
      </Styled.Description>
      <Button onClick={handleClick}>Voltar ao início</Button>
    </Styled.Wrapper>
  )
}

export default GenericError
